<template>
  <router-view></router-view>
  <template v-if="canShowRibbon">
    <EnvironmentRibbon />
  </template>
  <Confirm />
  <p v-if="isInactiveTooLong">Sei stato inattivo troppo a lungo. Sessione scaduta.</p>

  <div v-if="alertStore.visible" class="max-w-screen-sm w-auto fixed z-50" :class="dynamicClass">
    <v-alert
      :icon="alertStore.icon"
      density="compact"
      :type="alertStore.type"
      :text="alertStore.message"
    ></v-alert>
  </div>
</template>

<script setup lang="ts">
import EnvironmentRibbon from "./components/common/EnvironmentRibbon.vue";
import Confirm from "@/components/common/Confirm.vue";
import { computed } from "vue";
import { useAlert } from "@/store/alert";
import { VAlert } from "vuetify/components/VAlert";

import { useInactivityDetector } from "@/composables/useInactivityDetector";

const { isInactiveTooLong } = useInactivityDetector({
  requireTabHidden: false,
  onInactivity: () => {
    window.location.reload();
    // logoutUser();
  },
});

const alertStore = useAlert();

const canShowRibbon = computed((): boolean => {
  return ["development", "staging"].indexOf(import.meta.env.MODE) >= 0;
});

// Dynamic class computation for the alert
const dynamicClass = computed(() => {
  return alertStore.top
    ? `top-6 left-[50%] alert_wrapper alert_wrapper__${alertStore.type}`
    : `right-6 bottom-2 alert_wrapper alert_wrapper__${alertStore.type}`;
});
</script>

<style lang="postcss">
.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line {
  @apply mx-2 text-gray-800 font-medium text-sm cursor-pointer;
}
.v-list-item--density-default:not(.v-list-item--nav).v-list-item--one-line:hover {
  @apply bg-[#F2F8FF] text-[#004C9C] font-semibold cursor-pointer;
}
</style>
